import Vue from "vue";

Vue.component("covered-products", {
	props: [
		"hsCodes",
		"icsCodes",
		"notificationId"
	],
	data() {
		return {
			hsProducts: [],
			hsProductsLoading: false,
			icsProducts: [],
			icsProductsLoading: false,
			domain: 0
		};
	},
	computed: {
		noData() {
			return htmlEntity.decode(window.labels.noData);
		},
		loadingText() {
			return htmlEntity.decode(window.labels.loading);
		},
		hsProductsTable() {
			return `${window.labels.product} (${window.labels.hsCodes})`;
		},
		icsProductsTable() {
			return `${window.labels.product} (${window.labels.icsCodes})`;
		},
		propertyHsVersion() {
			return window.labels.version;
		},
		propertyDisplayName() {
			return window.labels.coveredProduct;
		},
		propertyInterpreted() {
			return window.labels.interpreted;
		},
		fromParentLabel() {
			return window.labels.fromParent;
		},
	},
	methods: {
		getNotificationHSProducts: function () {
			this.hsProductsLoading = true;
			this.$services.hsProducts.getNotificationHSProducts({
					language: window.currentLanguageEnum,
					hsProductIds: this.hsCodes,
					notificationId: this.notificationId
				})
				.then((data) => {
					this.hsProducts = data;
					this.hsProductsLoading = false;
				});
		},
		getNotificationICSProducts: function () {
			this.icsProductsLoading = true;
			this.$services.icsProducts.getNotificationICSProducts({
					language: window.currentLanguageEnum,
					icsProductIds: this.icsCodes,
					notificationId: this.notificationId
				})
				.then((data) => {
					this.icsProducts = data;
					this.icsProductsLoading = false;
				});
		},
		getNotificationDomain: function () {
			this.$services.notifications.getNotificationDomain({
				id: this.notificationId
			})
				.then((data) => {
					this.domain = data;
				});
		},
	},
	mounted: function () {
		this.getNotificationHSProducts();
		this.getNotificationICSProducts();
		this.getNotificationDomain();
	},
	template: `
		<section>
			<div v-if="hsProductsLoading">
				<loading :loading-text="loadingText"></loading>
			</div>
			<div v-else>
				<div class="columns">
					<div class="column">
						<b-field :label="hsProductsTable">
							<b-table :striped="true"
									 :narrowed="true"
									 :hoverable="true"
									 :data="hsProducts"
									 :show-detail-icon="false"
									 ref="hsProductsRef"
									 detailed
									 detail-key="id">
								<b-table-column field="version" :label="propertyHsVersion" width="10%" v-slot="props">
									HS {{ props.row.year }}
								</b-table-column>
								<b-table-column field="displayName" :label="propertyDisplayName" width="60%" v-slot="props">
									{{ props.row.displayName }}
								</b-table-column>
								<b-table-column field="interpreted" :label="propertyInterpreted" width="15%" v-slot="props">
									{{ props.row.interpreted }}
								</b-table-column>
								  <b-table-column v-if="domain == 1" field="forParent" :label="fromParentLabel" width="15%" v-slot="props">
									{{ props.row.forParent }}
								  </b-table-column>
								<template #empty>
					                <div class="has-text-centered">{{ noData }}</div>
					            </template>
							</b-table>
						</b-field>
					</div>
				</div>
			</div>
			<div v-if="icsProductsLoading">
				<loading :loading-text="loadingText"></loading>
			</div>
			<div v-else>
				<div class="columns">
					<div class="column">
						<b-field :label="icsProductsTable">
							<b-table :striped="true"
									 :narrowed="true"
									 :hoverable="true"
									 :data="icsProducts"
									 :show-detail-icon="false"
									 ref="icsProductsRef"
									 detailed
									 detail-key="id">
								<b-table-column field="displayName" :label="propertyDisplayName" width="70%" v-slot="props">
									{{ props.row.displayName }}
								</b-table-column>
								<b-table-column field="interpreted" :label="propertyInterpreted" width="15%" v-slot="props">
									{{ props.row.interpreted }}
								</b-table-column>
								  <b-table-column v-if="domain == 1" field="forParent" :label="fromParentLabel" width="15%" v-slot="props">
									{{ props.row.forParent }}
								  </b-table-column>
								<template #empty>
					                <div class="has-text-centered">{{ noData }}</div>
					            </template>
							</b-table>
						</b-field>
					</div>
				</div>
			</div>
		</section>
	`
});